export const lowImportanceMenuText = "OcAvS";
export default {lowImportanceMenuText};